import strings from "./strings.json";
import header from "./header.json";
import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import invoiceimg from "./invoiceimg.json";
import md5 from 'md5';

const CountdownTimer = ({ targetDateStr }) => {
  const targetDate = new Date(targetDateStr.replace(" ", "T")); // Convert to valid Date format
  const calculateTimeLeft = () => {
    const difference = targetDate - new Date();
    const rdifference = new Date() - targetDate;
    return difference > 0 ? {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / (1000 * 60)) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        } : 
        {
          daysMinus: Math.floor(rdifference / (1000 * 60 * 60 * 24)),
          hoursMinus: Math.floor((rdifference / (1000 * 60 * 60)) % 24),
          minutesMinus: Math.floor((rdifference / (1000 * 60)) % 60),
          secondsMinus: Math.floor((rdifference / 1000) % 60),
        };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);
  
  return (
    <td style={{ color: timeLeft.seconds > 0 ? "black" : "red" }} >
      {timeLeft.seconds > 0 ? (
        `${timeLeft.days}d ${timeLeft.hours}h ${timeLeft.minutes}m ${timeLeft.seconds}s`
      ) : timeLeft.secondsMinus > 0 ? (
        `-${timeLeft.daysMinus}d ${timeLeft.hoursMinus}h ${timeLeft.minutesMinus}m ${timeLeft.secondsMinus}s`
      ) : ""}
    </td>
  );
};

function Rents({ lang }) {
  const [iniForm, setIniForm] = useState(0); // iniForm = 0 Closed Form, 1 Add Form, 2 View Form, 3 Update Form, 4
  const [viewId, setViewId] = useState(0);
  const [data, setData] = useState([]);
  const [cars, setCars] = useState("");
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [date, setDate] = useState("");
  const [fileNo, setFileNo] = useState("");
  const [drivingLicence, setDrivingLicence] = useState("");
  const [issuePlace, setIssuePlace] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [carModel, setCarModel] = useState("");
  const [carNo, setCarNo] = useState("");
  const [timeOut, setTimeOut] = useState("");
  const [timeIn, setTimeIn] = useState("");
  const [timeReplaced, setTimeReplaced] = useState("");
  const [invoice, setInvoice] = useState("");
  const [company, setCompany] = useState("");
  const [disableComp, setDisableComp] = useState(false);
  const [refund, setRefund] = useState(0);
  const [images, setImages] = useState(""); // Check out images
  const [images1, setImages1] = useState(""); // Check in images
  const [dayCharge, setDayCharge] = useState(0);
  const [dayDinar, setDayDinar] = useState(0);
  const [dayFils, setDayFils] = useState(0);
  const [weekCharge, setWeekCharge] = useState(0);
  const [weekDinar, setWeekDinar] = useState(0);
  const [weekFils, setWeekFils] = useState(0);
  const [monthCharge, setMonthCharge] = useState(0);
  const [monthDinar, setMonthDinar] = useState(0);
  const [monthFils, setMonthFils] = useState(0);
  const [discountDinar, setDiscountDinar] = useState(0);
  const [discountFils, setDiscountFils] = useState(0);
  const [vatDinar, setVatDinar] = useState(0);
  const [vatFils, setVatFils] = useState(0);
  const [insuranceDinar, setInsuranceDinar] = useState(0);
  const [insuranceFils, setInsuranceFils] = useState(0);
  const [deliveryDinar, setDeliveryDinar] = useState(0);
  const [deliveryFils, setDeliveryFils] = useState(0);
  const [totalDinar, setTotalDinar] = useState(0);
  const [totalFils, setTotalFils] = useState(0);
  const [outFuel, setOutFuel] = useState(0);
  const [inFuel, setInFuel] = useState(0);
  const [outKm, setOutKm] = useState(0);
  const [inKm, setInKm] = useState(0);
  const [sticker, setSticker] = useState(false);
  const [aerial, setAerial] = useState(false);
  const [radio, setRadio] = useState(false);
  const [tools, setTools] = useState(false);
  const [jack, setJack] = useState(false);
  const [spare, setSpare] = useState(false);
  const [last, setLast] = useState("");
  const tableRef = useRef(null)
  const sigRef3 = useRef();
  const sigRef4 = useRef();
  const [comment, setComment] = useState(""); // Checkin Signature (LDown)
  const [signature3, setSignature3] = useState(0); // Hirer Signature (RDown)
  const [signature4, setSignature4] = useState(0); // Last Signature (Down)
  const [visibleButtons, setVisibleButtons] = useState(true);
  let [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");
  const [carsDisable, setCarsDisable] = useState(true);
  const [plateDisable, setPlateDisable] = useState(true);
  const [totalPrice, setTotalPrice] = useState("");
  const [totalDch, setTotalDch] = useState("");
  const [totalDis, setTotalDis] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dldmodal, setDldModal] = useState(false);
  const random = Math.random();
  const companies = ['HARD ROCK RIDERS', 'BRAXTONE PLUS', 'GULF ASSIST CO'];

  const today = new Date();
  const formattedDate = today.toLocaleDateString();

  const openDownloadModal = () => {
    document.getElementById("myCompany1").selectedIndex = 0;
    setDldModal(!dldmodal);
    setDisableComp(false);
    setCompany("");
    setStartDate("");
    setEndDate("");
    setSearch("");
    fetchData();
    const modalDiv = document.querySelector(".booking-modal__car-info");
    modalDiv.scroll(0, 0);
  }
  
  const generatePdf = () => {
    const element = document.getElementById("content");
    html2canvas(element)
      .then(() => {
        // const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        pdf.addImage(header.svg, 0, 0, 210, 300);
        pdf.setFontSize(13);
        pdf.text(filteredData[viewId].name, 21, 81);
        pdf.text(filteredData[viewId].invoice, 166, 81); // Right
        pdf.text("Driving License No.: "+filteredData[viewId].drivingLicence, 21, 87);
        pdf.text("Mobile No.: "+filteredData[viewId].mobile, 21, 93);
        pdf.text("Car Type: "+filteredData[viewId].carModel, 21, 99);
        pdf.text(filteredData[viewId].date, 163, 99); // Right
        pdf.text("Car Plate No.: "+filteredData[viewId].carNo, 21, 106);
        pdf.text("("+filteredData[viewId].dayCharge+"d "+filteredData[viewId].weekCharge+"w "+filteredData[viewId].monthCharge+"m)", 43, 137);
        let rentAmount = parseInt(filteredData[viewId].dayDinar*filteredData[viewId].dayCharge)+parseInt(filteredData[viewId].weekDinar*filteredData[viewId].weekCharge)+parseInt(filteredData[viewId].monthDinar*filteredData[viewId].monthCharge);
        pdf.text(rentAmount+" BD", 143, 137); // Right
        pdf.text(filteredData[viewId].vatDinar+" BD", 143, 152); // Right
        pdf.text(filteredData[viewId].insuranceDinar+" BD", 143, 166);
        pdf.text(filteredData[viewId].deliveryDinar+" BD", 143, 179);
        pdf.text((rentAmount+parseFloat(filteredData[viewId].vatDinar)+parseFloat(filteredData[viewId].insuranceDinar)+parseFloat(filteredData[viewId].deliveryDinar)).toFixed(2)+" BD", 143, 196);
        pdf.text(filteredData[viewId].discountDinar+" BD", 143, 203);
        pdf.text(filteredData[viewId].totalDinar+" BD", 143, 221);
        setTimeout(() => {
          pdf.save("Invoice" + filteredData[viewId].invoice + ".pdf");
          setVisibleButtons(true);
          setIniForm(0);
        }, 1000);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };

  const pregeneratePdf = () => {
    setVisibleButtons(false);
    setTimeout(() => {
      generatePdf();
    }, 1000);
  };

  const generateCompPdf = ( invoiceNumber ) => {
    const element1 = document.getElementById("content1");
    html2canvas(element1)
      .then(() => {
        // const imgData = canvas1.toDataURL("image/png");
        const subtotalAmt = totalPrice + totalDch - totalDis;
        const vatAmt = subtotalAmt * 0.1;
        const pdf = new jsPDF();
        pdf.addImage(invoiceimg.svg, 0, 0, 210, 300);
        pdf.setFontSize(13);
        pdf.text(invoiceNumber, 166, 81);
        pdf.text(company+" W.L.L", 21, 83);
        if (company === 'GULF ASSIST CO') {
        pdf.text("Office#11 Bulding#2332 Road#2830 Block#428", 21, 90);
        pdf.text("Al Seef District P.O.Box:2790 Manama", 21, 97);
        pdf.text("Kingdom of Bahrain TRN:220000618700002", 21, 104);
        } else if (company === 'BRAXTONE PLUS') {
        pdf.text("Flat/Shop No. 21, Building 2304, Road/Street 2830", 21, 90);
        pdf.text("AL SEEF, Block 428 Bahrain", 21, 97);
        pdf.text("TAN: 220001304300002 CR NO. 86167-1", 21, 104);
        } else {
        pdf.text("Office#1775 Road#840 Block708 Salmabad", 21, 90);
        pdf.text("TAN:220019160900002 CR NO. 152036-1", 21, 97 );
        }
        pdf.text(new Date((new Date().getTime()) + 3 * 60 * 60 * 1000).toISOString().split("T")[0], 163, 98); // Right
        pdf.text("Car Replacement services ("+filteredData.length+") : " + startDate + " - " + endDate, 21, 137);
        pdf.text("Delivery Charges", 21, 152);
        pdf.text(totalPrice+" BD", 143, 137); // Right
        pdf.text(totalDch+" BD", 143, 152); // Right
        if (totalDis > 0){
        pdf.text("Discounts", 21, 166);
        pdf.text(totalDis+" BD", 143, 166);
      }
        pdf.text(vatAmt.toFixed(3)+" BD", 143, 199);
        pdf.text((subtotalAmt+vatAmt)+" BD", 143, 221);

        setTimeout(() => {
          pdf.save(invoiceNumber+".pdf");
          openDownloadModal();
          addInvoice();
        }, 1000);
      })
      .catch((error) => {
        console.error("Error generating Company PDF:", error);
      });
  };

  const fetchData = async (e) => {
    try {
      const response = await axios({
        method: "get",
        url: "https://api.hardrockrental.net/getAllForms.php",
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data === "No data found.") {
        setFilteredData([]);
        setId("1");
        setData([]);
      } else {
        setFilteredData(response.data);
        setData(response.data);
        fetchId();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleCompany = (event) => {
    setCompany(event.target.value);
    setDisableComp(true);
  };

  const [pressTimer, setPressTimer] = useState(null);
  const [pressDuration, setPressDuration] = useState(0);

  const handlePressStart = () => {
    const startTime = Date.now();
    const timer = setTimeout(() => {
      setPressDuration(Date.now() - startTime);
    }, 1000); // 3 seconds threshold
    setPressTimer(timer);
  };

  const handlePressEnd = async (updateId, updateInsurance, updateTotal) => {
    var refundData = new FormData();
    if (pressTimer) {
      clearTimeout(pressTimer);
      setPressTimer(null);
    if (pressDuration >= 1000) {
    refundData.append("id", updateId);
    refundData.append("refund", 1);
    refundData.append("totalDinar", updateTotal-updateInsurance);
    refundData.append("signature2", sessionStorage.getItem("userdata"));
    refundData.append("signature4", "0000-00-00 00:00:00");
    try {
      await axios({
        method: "post",
        url: "https://api.hardrockrental.net/updateRefund.php",
        data: refundData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      fetchData();
      setPressDuration(0);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
    }
  };

  const topCar = () => {
    const modelCounts = data.reduce((acc, car) => {
      acc[car.carModel] = (acc[car.carModel] || 0) + 1; // Count occurrences of each carModel
      return acc;
    }, {});

    let mostDuplicatedCar = "";
    let maxCount = 0;

    for (const [carModel, count] of Object.entries(modelCounts)) {
      if (count > maxCount) {
        mostDuplicatedCar = carModel;
        maxCount = count;
      }
    }
    
    return mostDuplicatedCar + " ("+maxCount+")";
  };

  const topRenter = () => {
    const modelCounts = data.reduce((acc, car) => {
      acc[car.drivingLicence] = (acc[car.drivingLicence] || 0) + 1; // Count occurrences of each drivingLicence
      return acc;
    }, {});

    let mostDuplicatedCar = "";
    let maxCount = 0;

    for (const [drivingLicence, count] of Object.entries(modelCounts)) {
      if (count > maxCount) {
        mostDuplicatedCar = drivingLicence;
        maxCount = count;
      }
    }
    
    return mostDuplicatedCar + " ("+maxCount+")";;
  };

  const fetchId = async () => {
    try {
      const response = await axios({
        method: "get",
        url: "https://api.hardrockrental.net/getFormsid.php",
        headers: { "Content-Type": "multipart/form-data" },
      });
      setId(parseInt(response.data["MAX(id)"]) + 1);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchCars = async () => {
    try {
      const response = await axios({
        method: "get",
        url: "https://api.hardrockrental.net/getCarNames.php",
        headers: { "Content-Type": "multipart/form-data" },
      });
      setCars(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchCars();
    fetchId();
  }, []);

  const searchSpace = (event) => {
    setSearch(event.target.value);
    if(event.target.value === "") {
      setFilteredData(data);
    } else {
      filteredData = data.filter((datas)=>{
        if((datas.name).includes(search.toUpperCase()) || (datas.mobile).includes(search) || (datas.carModel).includes(search.toUpperCase()) || (datas.carNo).includes(search) || (datas.fileNo).includes(search) || (datas.drivingLicence).includes(search) || (datas.company).includes(search.toUpperCase())){
          return datas
        } else {
          return false;
        }
      });
      setFilteredData(filteredData);
    }
  }

  var addformData = new FormData();
  // formData.append('id', last);

  const addForm = async () => {
    const errorMsg = document.querySelector(".error-message");
    if (company === "") {
  errorMsg.textContent = "Company name is required.";
  errorMsg.style.display = "flex";
} else if (name === "") {
  errorMsg.textContent = "Name is required.";
  errorMsg.style.display = "flex";
} else if (mobile === "") {
  errorMsg.textContent = "Mobile number is required.";
  errorMsg.style.display = "flex";
} else if (date === "") {
  errorMsg.textContent = "Date is required";
  errorMsg.style.display = "flex";
} else if (invoice === "") {
  errorMsg.textContent = "Invoice number is required.";
  errorMsg.style.display = "flex";
} else if (insuranceDinar === "") {
  errorMsg.textContent = "Insurance amount is required.";
  errorMsg.style.display = "flex";
} else if (carModel === "") {
  errorMsg.textContent = "Car model is required.";
  errorMsg.style.display = "flex";
} else if (carNo === "") {
  errorMsg.textContent = "Plate number is required.";
  errorMsg.style.display = "flex";
} else if (drivingLicence === "") {
  errorMsg.textContent = "Driving licence number is required.";
  errorMsg.style.display = "flex";
} else {
  errorMsg.textContent = "";
  errorMsg.style.display = "none";
      handleImageUpload();
      // handleImageUpload1();
      addformData.append("name", name.toUpperCase());
      addformData.append("mobile", mobile);
      addformData.append("date", date);
      addformData.append("fileNo", fileNo);
      addformData.append("drivingLicence", drivingLicence);
      addformData.append("issuePlace", issuePlace);
      addformData.append("expiryDate", expiryDate);
      addformData.append("carModel", carModel);
      addformData.append("carNo", carNo);
      addformData.append("timeOut", timeOut);
      addformData.append("timeIn", timeIn);
      addformData.append("timeReplaced", timeReplaced);
      addformData.append("invoice", invoice);
      addformData.append("company", company);
      addformData.append("refund", 0);
      addformData.append("dayCharge", dayCharge);
      addformData.append("dayDinar", dayDinar);
      addformData.append("dayFils", dayFils);
      addformData.append("weekCharge", weekCharge);
      addformData.append("weekDinar", weekDinar);
      addformData.append("weekFils", weekFils);
      addformData.append("monthCharge", monthCharge);
      addformData.append("monthDinar", monthDinar);
      addformData.append("monthFils", monthFils);
      addformData.append("discountDinar", discountDinar);
      addformData.append("discountFils", discountFils);
      addformData.append("vatDinar", parseFloat(((dayCharge*dayDinar)+(weekCharge*weekDinar)+(monthCharge*monthDinar))*0.1).toFixed(2));
      addformData.append("vatFils", vatFils);
      addformData.append("insuranceDinar", insuranceDinar);
      addformData.append("insuranceFils", insuranceFils);
      addformData.append("deliveryDinar", deliveryDinar);
      addformData.append("deliveryFils", deliveryFils);
      addformData.append("totalDinar", parseFloat(parseFloat((dayCharge*dayDinar)+(weekCharge*weekDinar)+(monthCharge*monthDinar)+parseFloat(deliveryDinar)+parseFloat(insuranceDinar)-parseFloat(discountDinar))+parseFloat(((dayCharge*dayDinar)+(weekCharge*weekDinar)+(monthCharge*monthDinar))*0.1)).toFixed(2));
      addformData.append("totalFils", totalFils);
      addformData.append("outFuel", outFuel);
      addformData.append("inFuel", inFuel);
      addformData.append("outKm", outKm);
      addformData.append("inKm", inKm);
      addformData.append("sticker", sticker);
      addformData.append("aerial", aerial);
      addformData.append("radio", radio);
      addformData.append("tools", tools);
      addformData.append("jack", jack);
      addformData.append("spare", spare);
      addformData.append("signature", sessionStorage.getItem("userdata"));
      addformData.append("comment", comment);
      addformData.append("signature2", sessionStorage.getItem("userdata"));
      addformData.append("signature3", signature3);
      addformData.append("signature4", signature4);
      addformData.append("images", selectedImages.length === 0 ? "" : selectedImages[0].name);
      addformData.append("images1", images1);
      // addRent();
      try {
        await axios({
          method: "post",
          url: "https://api.hardrockrental.net/addForm.php",
          data: addformData,
          headers: { "Content-Type": "multipart/form-data" },
        });
        fetchData();
        closeForm();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  var updateformData = new FormData();

  const updateForm = async () => {
    const errorMsg = document.querySelector(".error-message");
    if (
      name === "" ||
      mobile === "" ||
      date === "" ||
      dayDinar === "" ||
      totalDinar === "" ||
      carNo === "" ||
      drivingLicence === ""
    ) {
      errorMsg.style.display = "flex";
    } else {
      errorMsg.style.display = "none";
      handleImageUpload2();
      handleImageUpload();
      // handleImageUpload1();
      updateformData.append("id", id);
      updateformData.append("name", name);
      updateformData.append("mobile", mobile);
      updateformData.append("fileNo", fileNo);
      updateformData.append("drivingLicence", drivingLicence);
      updateformData.append("issuePlace", issuePlace);
      updateformData.append("expiryDate", expiryDate);
      updateformData.append("carModel", carModel);
      updateformData.append("carNo", carNo);
      updateformData.append("timeOut", timeOut);
      updateformData.append("timeIn", timeIn);
      updateformData.append("timeReplaced", timeReplaced);
      updateformData.append("invoice", invoice);
      updateformData.append("company", company);
      updateformData.append("refund", 0);
      updateformData.append("dayCharge", dayCharge);
      updateformData.append("dayDinar", dayDinar);
      updateformData.append("dayFils", dayFils);
      updateformData.append("weekCharge", weekCharge);
      updateformData.append("weekDinar", weekDinar);
      updateformData.append("weekFils", weekFils);
      updateformData.append("monthCharge", monthCharge);
      updateformData.append("monthDinar", monthDinar);
      updateformData.append("monthFils", monthFils);
      updateformData.append("discountDinar", discountDinar);
      updateformData.append("discountFils", discountFils);
      updateformData.append("vatDinar", vatDinar);
      updateformData.append("vatFils", vatFils);
      updateformData.append("insuranceDinar", insuranceDinar);
      updateformData.append("insuranceFils", insuranceFils);
      updateformData.append("deliveryDinar", deliveryDinar);
      updateformData.append("deliveryFils", deliveryFils);
      updateformData.append("totalDinar", totalDinar);
      updateformData.append("totalFils", totalFils);
      updateformData.append("outFuel", outFuel);
      updateformData.append("inFuel", inFuel);
      updateformData.append("outKm", outKm);
      updateformData.append("inKm", inKm);
      updateformData.append("sticker", sticker);
      updateformData.append("aerial", aerial);
      updateformData.append("radio", radio);
      updateformData.append("tools", tools);
      updateformData.append("jack", jack);
      updateformData.append("spare", spare);
      updateformData.append("comment",comment);
      updateformData.append("signature2", sessionStorage.getItem("userdata"));
      updateformData.append(
        "signature3",
        sigRef3.current === undefined || sigRef3.current === null
          ? signature3
          : sigRef3.current.toDataURL()
      );
      if (inKm > 0 && inFuel > 0) {
        const now = new Date();
        now.setDate(now.getDate() + 7); // Add 7 days
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        const seconds = String(now.getSeconds()).padStart(2, "0");
        updateformData.append("signature4", `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`);
      } else {
        updateformData.append("signature4", "0000-00-00 00:00:00");
      }
      updateformData.append("images", images);
      updateformData.append("images1", selectedImages.length === 0 ? "" : selectedImages[0].name);
      try {
        await axios({
          method: "post",
          url: "https://api.hardrockrental.net/updateForm.php",
          data: updateformData,
          headers: { "Content-Type": "multipart/form-data" },
        });
        fetchData();
        closeUpdateForm();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const hideError = () => {
    const errorMsg = document.querySelector(".error-message");
    errorMsg.style.display = "none";
  };

  const viewForm = (id) => {
    setIniForm(2);
    setViewId(id);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    
    // Extract YYYY-MM-DD
    const formattedDate = date.toISOString().split('T')[0];

    // Extract AM/PM time
    const timeOptions = { hour: '2-digit', minute: '2-digit', hour12: true };
    const formattedTime = date.toLocaleTimeString('en-US', timeOptions);

    return `${formattedDate} ${formattedTime}`;
};

  const fetchRents = async (e) => {
    try {
      const response = await axios({
        method: "get",
        url: "https://api.hardrockrental.net/getRents.php",
        headers: { "Content-Type": "multipart/form-data" },
      });
      // setLast(response.data[response.data.length - 1].id + 1);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  var rentData = new FormData();
  rentData.append("id", last);

  // const addRent = async () => {
  //   rentData.append("car", carModel);
  //   rentData.append("plate", carNo);
  //   rentData.append("car_out", timeOut);
  //   rentData.append("car_in", timeIn);
  //   try {
  //     await axios({
  //       method: "post",
  //       url: "https://api.hardrockrental.net/addRent.php",
  //       data: rentData,
  //       headers: { "Content-Type": "multipart/form-data" },
  //     });
  //     fetchRents();
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  const editForm = (
    idx,
    id,
    name,
    mobile,
    date,
    fileNo,
    drivingLicence,
    issuePlace,
    expiryDate,
    carModel,
    carNo,
    timeOut,
    timeIn,
    timeReplaced,
    invoice,
    company,
    refund,
    images,
    images1,
    dayCharge,
    dayDinar,
    dayFils,
    weekCharge,
    weekDinar,
    weekFils,
    monthCharge,
    monthDinar,
    monthFils,
    discountDinar,
    discountFils,
    vatDinar,
    vatFils,
    insuranceDinar,
    insuranceFils,
    deliveryDinar,
    deliveryFils,
    totalDinar,
    totalFils,
    outFuel,
    inFuel,
    outKm,
    inKm,
    sticker,
    aerial,
    radio,
    tools,
    jack,
    spare,
    signature,
    comment,
    signature2,
    signature3,
    signature4
  ) => {
    setIniForm(3);
    setViewId(idx);
    setId(id);
    setName(name);
    setMobile(mobile);
    setDate(date);
    setFileNo(fileNo);
    setDrivingLicence(drivingLicence);
    setIssuePlace(issuePlace);
    setExpiryDate(expiryDate);
    setCarModel(carModel);
    setCarNo(carNo);
    setTimeOut(timeOut);
    setTimeIn(timeIn);
    setTimeReplaced(timeReplaced);
    setInvoice(invoice);
    setCompany(company);
    setRefund(refund);
    setImages(images);
    setImages1(images1);
    setDayCharge(dayCharge);
    setDayDinar(dayDinar);
    setDayFils(dayFils);
    setWeekCharge(weekCharge);
    setWeekDinar(weekDinar);
    setWeekFils(weekFils);
    setMonthCharge(monthCharge);
    setMonthDinar(monthDinar);
    setMonthFils(monthFils);
    setDiscountDinar(discountDinar);
    setDiscountFils(discountFils);
    setVatDinar(vatDinar);
    setVatFils(vatFils);
    setInsuranceDinar(insuranceDinar);
    setInsuranceFils(insuranceFils);
    setDeliveryDinar(deliveryDinar);
    setDeliveryFils(deliveryFils);
    setTotalDinar(totalDinar);
    setTotalFils(totalFils);
    setOutFuel(outFuel);
    setInFuel(inFuel);
    setOutKm(outKm);
    setInKm(inKm);
    setSticker(sticker);
    setAerial(aerial);
    setRadio(radio);
    setTools(tools);
    setJack(jack);
    setSpare(spare);
    setComment(comment);
    setSignature3(signature3);
    setSignature4(signature4);
  };

  const dateNow = new Date().getTime();

  const handleDayCharge = (e) => {
    const weekCalc = parseInt(weekCharge) * 7;
    const weekCalcTotal = weekCalc+parseInt(e);
    const monthCalc = parseInt(monthCharge) * 30;
    const monthCalcTotal = monthCalc+parseInt(e);
    const monthAndWeek = monthCalc+weekCalc+parseInt(e);
    if (!isNaN(e) && parseInt(e) <= 6) {
      setDayCharge(e);
      if (parseInt(weekCharge) === 0 && parseInt(monthCharge) === 0) {
        setTimeIn(new Date((dateNow) + e * 24 * 60 * 60 * 1000 + 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
        availableCars(new Date((dateNow) + e * 24 * 60 * 60 * 1000 + 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
      } else if (parseInt(weekCharge) > 0 && parseInt(monthCharge) === 0) {
        setTimeIn(new Date((dateNow) + weekCalcTotal * 24 * 60 * 60 * 1000 + 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
        availableCars(new Date((dateNow) + weekCalcTotal * 24 * 60 * 60 * 1000 + 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
      } else if (parseInt(weekCharge) === 0 && parseInt(monthCharge) > 0) {
        setTimeIn(new Date((dateNow) + monthCalcTotal * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
        availableCars(new Date((dateNow) + monthCalcTotal * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
      } else if (parseInt(weekCharge) > 0 && parseInt(monthCharge) > 0) {
        setTimeIn(new Date((dateNow) + monthAndWeek * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
        availableCars(new Date((dateNow) + monthAndWeek * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
      }
    }
  }

  const handleWeekCharge = (e) => {
    const weekCalc = parseInt(e) * 7;
    const dayCalc = weekCalc + parseInt(dayCharge);
    const monthCalc = parseInt(monthCharge) * 30;
    const monthCalcTotal = monthCalc+weekCalc;
    const monthAndDay = monthCalc+weekCalc+parseInt(dayCharge);
    if (!isNaN(e) && parseInt(e) <= 4) {
      setWeekCharge(e);
      if (parseInt(dayCharge) === 0 && parseInt(monthCharge) === 0) {
        setTimeIn(new Date((dateNow) + weekCalc * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
        availableCars(new Date((dateNow) + weekCalc * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
      } else if (parseInt(dayCharge) > 0 && parseInt(monthCharge) === 0) {
        setTimeIn(new Date((dateNow) + dayCalc * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
        availableCars(new Date((dateNow) + dayCalc * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
      } else if (parseInt(dayCharge) === 0 && parseInt(monthCharge) > 0) {
        setTimeIn(new Date((dateNow) + monthCalcTotal * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
        availableCars(new Date((dateNow) + monthCalcTotal * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
      } else if (parseInt(dayCharge) > 0 && parseInt(monthCharge) > 0) {
        setTimeIn(new Date((dateNow) + monthAndDay * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
        availableCars(new Date((dateNow) + monthAndDay * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
      }
    }
  }

  const handleMonthCharge = (e) => {
    const monthCalc = parseInt(e) * 30;
    const dayCalc = monthCalc + parseInt(dayCharge);
    const weekCalc = parseInt(weekCharge) * 7;
    const weekCalcTotal = weekCalc+monthCalc;
    const weekAndDay = monthCalc+weekCalc+parseInt(dayCharge);
    if (!isNaN(e) && parseInt(e) >= 0) {
      setMonthCharge(e);
      if (parseInt(dayCharge) === 0 && parseInt(weekCharge) === 0) {
        setTimeIn(new Date((dateNow) + monthCalc * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
        availableCars(new Date((dateNow) + monthCalc * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
      } else if (parseInt(dayCharge) > 0 && parseInt(weekCharge) === 0) {
        setTimeIn(new Date((dateNow) + dayCalc * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
        availableCars(new Date((dateNow) + dayCalc * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
      } else if (parseInt(dayCharge) === 0 && parseInt(weekCharge) > 0) {
        setTimeIn(new Date((dateNow) + weekCalcTotal * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
        availableCars(new Date((dateNow) + weekCalcTotal * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
      } else if (parseInt(dayCharge) > 0 && parseInt(weekCharge) > 0) {
        setTimeIn(new Date((dateNow) + weekAndDay * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
        availableCars(new Date((dateNow) + weekAndDay * 24 * 60 * 60 * 1000+ 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
      }
    }
  }

  var bodyFormData = new FormData();
  
    const availableCars = async(newTimeIn) => {
      setTimeIn(newTimeIn); // to be disabled
      setCarsDisable(false);
      bodyFormData.append('timeIn', newTimeIn); // to be replaced by below code
      bodyFormData.append('timeOut', timeOut);

      // new Date((new Date().getTime()) + 3 * 60 * 60 * 1000).toISOString() TO BE REPLACED IN TIME OUT BODYFORM
  
      try {
        const response = await axios({
          method: "post",
          url: "https://api.hardrockrental.net/getAvailableCars.php",
          data: bodyFormData,
          headers: { "Content-Type": "multipart/form-data" },
        });
        
        setCars(response.data);
        // console.log(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    const FormDld = (e) => {
      setEndDate(e);
      filteredData = data.filter(form => {
        const expiry = new Date(form.date);
        const start = new Date(startDate);
        const end = new Date(e);
    
        return (
            (start && end && expiry >= start && expiry <= end) &&
            (company === "" || form.company.toLowerCase() === company.toLowerCase())
        );
    });
    
    setTotalPrice(filteredData.reduce((sum, form) => parseInt(sum) + (parseInt(form.dayDinar) + parseInt(form.weekDinar) + parseInt(form.monthDinar)), 0));
    setTotalDis(filteredData.reduce((sum, form) => parseInt(sum) + (parseInt(form.discountDinar)), 0));
    setTotalDch(filteredData.reduce((sum, form) => parseInt(sum) + (parseInt(form.deliveryDinar)), 0));
    setFilteredData(filteredData);
    }
    
    const getInvoice = async() => {
      try {
        const response = await axios({
          method: "post",
          url: "https://api.hardrockrental.net/getInvoice.php",
          data: {"inv": "replacement"},
          headers: { "Content-Type": "multipart/form-data" },
        });
      const invoiced = (parseInt(response.data.invoiced)+1).toString().padStart(2, "0");
      const yearPrefix = new Date().getFullYear().toString().slice(-2); // Get last two digits of the current year
      const invoiceNumber = "CRI"+yearPrefix+invoiced;
      generateCompPdf(invoiceNumber);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    
    const addInvoice = async() => {
      try {
        await axios({
          method: "post",
          url: "https://api.hardrockrental.net/addInvoice.php",
          data: {"inv": "replacement"},
          headers: { "Content-Type": "multipart/form-data" },
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

  const [selectedImages, setSelectedImages] = useState([]);

  const closeUpdateForm = () => {
    setIniForm(0);
    setViewId(0);
    setPlateDisable(true);
    setDisableComp(false);
    setCompany("");
    setName("");
    setMobile("");
    setDate("");
    setFileNo("");
    setDrivingLicence("");
    setIssuePlace("");
    setExpiryDate("");
    setCarModel("");
    setCarNo("");
    setTimeOut("");
    setTimeIn("");
    setTimeReplaced("");
    setInvoice("");
    setCompany("");
    setRefund(0);
    setImages("");
    setImages1("");
    setDayCharge(0);
    setDayDinar(0);
    setDayFils(0);
    setWeekCharge(0);
    setWeekDinar(0);
    setWeekFils(0);
    setMonthCharge(0);
    setMonthDinar(0);
    setMonthFils(0);
    setDiscountDinar(0);
    setDiscountFils(0);
    setVatDinar(0);
    setVatFils(0);
    setInsuranceDinar(0);
    setInsuranceFils(0);
    setDeliveryDinar(0);
    setDeliveryFils(0);
    setTotalDinar(0);
    setTotalFils(0);
    setOutFuel(0);
    setInFuel(0);
    setOutKm(0);
    setInKm(0);
    setSticker(false);
    setAerial(false);
    setRadio(false);
    setTools(false);
    setJack(false);
    setSpare(false);
    setComment("");
    setSignature3("");
    setSignature4("");
    setSelectedImages([]);
    fetchId();
  };

  const closeForm = () => {
    setIniForm(0);
    setViewId(0);
    setPlateDisable(true);
    setDisableComp(false);
    document.getElementById("myCompany").selectedIndex = 0;
    setCompany("");
    setName("");
    setMobile("");
    setDate("");
    setFileNo("");
    setDrivingLicence("");
    setIssuePlace("");
    setExpiryDate("");
    setCarModel("");
    setCarNo("");
    setTimeOut("");
    setTimeIn("");
    setTimeReplaced("");
    setInvoice("");
    setCompany("");
    setRefund(0);
    setImages("");
    setImages1("");
    setDayCharge(0);
    setDayDinar(0);
    setDayFils(0);
    setWeekCharge(0);
    setWeekDinar(0);
    setWeekFils(0);
    setMonthCharge(0);
    setMonthDinar(0);
    setMonthFils(0);
    setDiscountDinar(0);
    setDiscountFils(0);
    setVatDinar(0);
    setVatFils(0);
    setInsuranceDinar(0);
    setInsuranceFils(0);
    setDeliveryDinar(0);
    setDeliveryFils(0);
    setTotalDinar(0);
    setTotalFils(0);
    setOutFuel(0);
    setInFuel(0);
    setOutKm(0);
    setInKm(0);
    setSticker(false);
    setAerial(false);
    setRadio(false);
    setTools(false);
    setJack(false);
    setSpare(false);
    setComment("");
    setSignature3("");
    setSignature4("");
    setSelectedImages([]);
    fetchId();
  };

  const handleFileChange = (event) => {
    setSelectedImages(event.target.files);
    // setImages(event.target.files.length);
  };

  const handleImageUpload = async () => {
    const files = selectedImages;
    const updatedImages = [];

    for (let i = 0; i < files.length; i++) {
      updatedImages.push(files[i]);
    }

    // Post images to API
    const formData2 = new FormData();
    for (let i = 0; i < updatedImages.length; i++) {
      formData2.append("pdfFile", updatedImages[i]);
      formData2.append("fileName", selectedImages[0].name);
      try {
        await axios({
          method: "post",
          url: "https://api.hardrockrental.net/uploadforms.php",
          data: formData2,
          headers: { "Content-Type": "multipart/form-data" },
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const [visibleRows, setVisibleRows] = useState(10);

  const handleLoadMore = () => {
    setVisibleRows((prevRows) => prevRows + 10);
  };

  const handleShowAll = () => {
    setVisibleRows(data.length);
  };

  const handleLoadLess = () => {
    setVisibleRows((prevRows) => prevRows - 10);
  };

  const handleImageUpload2 = async () => {
    const files = selectedImages;
    const updatedImages = [];

    for (let i = 0; i < files.length; i++) {
      updatedImages.push(files[i]);
    }

    // Post images to API
    const formData1 = new FormData();
    for (let i = 0; i < updatedImages.length; i++) {
      formData1.append("pdfFile", updatedImages[i]);
      formData1.append("fileName", selectedImages[0].name);
      try {
        await axios({
          method: "post",
          url: "https://api.hardrockrental.net/uploadforms.php",
          data: formData1,
          headers: { "Content-Type": "multipart/form-data" },
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  // const handleFileChange1 = (event) => {
  //   setSelectedImages1(event.target.files);
  //   setImages1(event.target.files.length);
  // };

  // const handleCarModel = (event) => {
  //   setSelectedImages1(event.target.files);
  //   setImages1(event.target.files.length);
  // };

  // const handleImageUpload1 = async () => {
  //   const files = [];
  //   const updatedImages = [];

  //   for (let i = 0; i < files.length; i++) {
  //     updatedImages.push(files[i]);
  //   }

  //   // Post images to API
  //   const formData = new FormData();
  //   // for (let i = 0; i < updatedImages.length; i++) {
  //   formData.append("PdfFile", 1);
  //   formData.append("fileName", "Form"+invoice+"-"+date+".pdf");
  //   try {
  //     await axios({
  //       method: "post",
  //       url: "https://api.hardrockrental.net/uploadforms.php",
  //       data: formData,
  //       headers: { "Content-Type": "multipart/form-data" },
  //     });
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  //   // }
  // };

  const calcTotalDinar = () => {
    let dinar =
      parseFloat(dayDinar) +
      parseFloat(weekDinar) +
      parseFloat(monthDinar) +
      parseFloat(vatDinar) +
      parseFloat(insuranceDinar) +
      parseFloat(deliveryDinar) -
      parseFloat(discountDinar);
    // let fils = parseFloat(dayFils)+parseFloat(weekFils)+parseFloat(monthFils)+parseFloat(vatFils)+parseFloat(insuranceFils)+parseFloat(deliveryFils)-parseFloat(discountFils);
    // let counter = Math.floor(fils / 1000);

    // if (fils >= 1000) {
    // fils = fils - (counter * 1000);
    // dinar = dinar + counter;
    // }
    // setTotalFils(fils);
    setTotalDinar(dinar);
  };

  const addNewForm = () => {
    setIniForm(1);
    setDate(new Date((new Date().getTime()) + 3 * 60 * 60 * 1000).toISOString().split("T")[0]);
    setTimeOut(new Date((new Date().getTime()) + 3 * 60 * 60 * 1000).toISOString().slice(0, 16));
  }

  const getCarModel = (e) => {
    setCarsDisable(true);
    setCarModel(e.target.value);
    setPlateDisable(false);
    // setDayDinar(cars[(e.target.options.selectedIndex-1)].daily*dayCharge);
    // setWeekDinar(cars[(e.target.options.selectedIndex-1)].weekly*weekCharge);
    // setMonthDinar(cars[(e.target.options.selectedIndex-1)].monthly*monthCharge);
    // let dwm = cars[(e.target.options.selectedIndex-1)].daily*dayCharge+cars[(e.target.options.selectedIndex-1)].weekly*weekCharge+cars[(e.target.options.selectedIndex-1)].monthly*monthCharge;
    // let vat = ((dwm+((10*(dwm))/100))-dwm).toFixed(2);
    // setVatDinar(vat);
    // setTotalDinar((parseFloat(dwm)-parseFloat(discountDinar))+parseFloat(vat)+parseFloat(insuranceDinar)+parseFloat(deliveryDinar));
  };

  const isNearBySixHours = (dateTime) => {
    const now = new Date();
    const givenDateTime = new Date(dateTime);
  
    const diffTime = (now - givenDateTime); // Difference in milliseconds
    const diffHours = diffTime / (1000 * 60 * 60); // Convert to hours
    
    return diffHours;
};

  return (
    <>
      {iniForm === 1 ? (
        <section className="testimonials-section">
          <div className="container">
            <div className="testimonials-content">
              <div className="testimonials-content__title">
                <h2>{strings[lang].Form1} #{id}</h2>
                <span>
                  <input
                    type="number"
                    placeholder={strings[lang].Form37}
                    value={invoice}
                    onChange={(e) => setInvoice(e.target.value)}
                  />{" "}
                  &nbsp;{" "}
                  <input
                    type="text"
                    placeholder={strings[lang].Form2}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />{" "}
                  &nbsp;{" "}
                  <input
                    type="number"
                    placeholder={strings[lang].Form3}
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                  />
                  {" "}
                  &nbsp;{" "}
                  <input
                    type="date"
                    placeholder="Date"
                    // disabled TO BE ENABLED
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </span>
              </div>
              <div
                className="all-testimonials"
                style={{ textAlign: lang === "ar" ? "right" : "left" }}
              >
                <div className="all-testimonials__table">
                  <table>
                    <thead>
                      <tr>
                        <th>
                          <p></p>
                        </th>
                        <th>
                          <b>{strings[lang].Form4}</b>
                        </th>
                        <th>
                          <b>{strings[lang].Form5}</b>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <p>{strings[lang].Form7}</p>
                        </td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={dayCharge}
                            min="0"
                            onClick={(e) => e.target.select()}
                            onChange={(e) => setDayCharge(e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={dayDinar}
                            min="0"
                            onClick={(e) => e.target.select()}
                            onChange={(e) => setDayDinar(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>{strings[lang].Form8}</p>
                        </td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={weekCharge}
                            min="0"
                            onClick={(e) => e.target.select()}
                            onChange={(e) => setWeekCharge(e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={weekDinar}
                            min="0"
                            onClick={(e) => e.target.select()}
                            onChange={(e) => setWeekDinar(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>{strings[lang].Form9}</p>
                        </td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            min="0"
                            value={monthCharge}
                            onClick={(e) => e.target.select()}
                            onChange={(e) => setMonthCharge(e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={monthDinar}
                            min="0"
                            onClick={(e) => e.target.select()}
                            onChange={(e) => setMonthDinar(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>{strings[lang].Form10}</p>
                        </td>
                        <td></td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            min="0"
                            value={discountDinar}
                            onClick={(e) => e.target.select()}
                            onChange={(e) => setDiscountDinar(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>{strings[lang].Form11}</p>
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center" }}>{parseFloat(((dayCharge*dayDinar)+(weekCharge*weekDinar)+(monthCharge*monthDinar))*0.1).toFixed(2)}</td>
                      </tr>
                      <tr>
                        <td>
                          <p>{strings[lang].Form12}</p>
                        </td>
                        <td></td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            min="0"
                            value={insuranceDinar}
                            onClick={(e) => e.target.select()}
                            onChange={(e) => setInsuranceDinar(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>{strings[lang].Form13}</p>
                        </td>
                        <td></td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            min="0"
                            value={deliveryDinar}
                            onClick={(e) => e.target.select()}
                            onChange={(e) => setDeliveryDinar(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>{strings[lang].Form14}</p>
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center" }}>{parseFloat(parseFloat((dayCharge*dayDinar)+(weekCharge*weekDinar)+(monthCharge*monthDinar)+parseFloat(deliveryDinar)+parseFloat(insuranceDinar)-parseFloat(discountDinar))+parseFloat(((dayCharge*dayDinar)+(weekCharge*weekDinar)+(monthCharge*monthDinar))*0.1)).toFixed(2)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div
                  className="all-testimonials__box"
                  style={{ display: "grid" }}
                >
                  <p>{strings[lang].Truck6}</p>{" "}
                  <select disabled={disableComp} id="myCompany" onChange={handleCompany}>
          <option value="" >{strings[lang].Truck8}</option>
        {companies.map((data, idx) => (
              <option key={idx} value={data}> {data} </option>
        ))}
        </select>
                  <p>{strings[lang].Form29}</p>{" "}
                  <input
                    type="number"
                    placeholder="Driving Licence No."
                    value={drivingLicence}
                    onChange={(e) => setDrivingLicence(e.target.value)}
                  />
                  <p>{strings[lang].Taxi3}</p>{" "}
                  <input
                    type="text"
                    placeholder="File No."
                    value={fileNo}
                    onChange={(e) => setFileNo(e.target.value)}
                  />
                  <p>{strings[lang].Form32}</p>{" "}
                  <select
                    value={carModel || ""}
                    disabled={carsDisable}
                    onChange={(e) => getCarModel(e)}
                  >
                    <option>{strings[lang].Upload2}</option>
                    {Array.from(
                      new Set(cars.map((car) => car.name + " " + car.model))
                    ).map((name, index) => {
                      return (
                        <option key={index} value={name}>
                          {" "}
                          {name}{" "}
                        </option>
                      );
                    })}
                  </select>
                  <p>{strings[lang].Form33}</p>{" "}
                  <select
                    value={carNo}
                    disabled={plateDisable}
                    onChange={(e) => setCarNo(e.target.value)}
                  >
                    <option>{strings[lang].Form56}</option>
                    {cars &&
                      cars
                        .filter(
                          (car) => car.name + " " + car.model === carModel
                        )
                        .map((car) => car.plate)
                        .map(function (plate, idx) {
                          return (
                            <option key={idx} value={plate}>
                              {" "}
                              {plate}{" "}
                            </option>
                          );
                        })}
                  </select>
                  <p>{strings[lang].Form34}</p>{" "}
                  <input
                    type="datetime-local"
                    placeholder="Date / Time out"
                    // disabled TO BE REMOVED
                    value={timeOut}
                    onChange={(e) => setTimeOut(e.target.value)}
                  />
                  <p>
                    {strings[lang].Form15} {strings[lang].Form17}
                  </p>{" "}
                  <input
                    type="number"
                    placeholder="Eg. 25"
                    value={outFuel}
                    onClick={(e) => e.target.select()}
                    onChange={(e) => setOutFuel(e.target.value)}
                  />
                  <p>
                    {strings[lang].Form15} {strings[lang].Form18}
                  </p>{" "}
                  <input
                    type="number"
                    placeholder="Eg. 3500"
                    value={outKm}
                    onClick={(e) => e.target.select()}
                    onChange={(e) => setOutKm(e.target.value)}
                  />
                  <p>{strings[lang].Form35}</p>{" "}
                  <input
                    type="datetime-local"
                    placeholder="Date / Time in"
                    value={timeIn}
                    onChange={(e) => availableCars(e.target.value)} // TO BE DISABLED
                    // disabled TO BE ENABLED
                    // min={new Date((new Date().getTime()) + dayCharge * 24 * 60 * 60 * 1000).toISOString().slice(0, 16)}
                    // max={new Date((new Date().getTime()) + dayCharge * 24 * 60 * 60 * 1000).toISOString().slice(0, 16)}
                    // disabled={
                    //   dayCharge > 0 || weekCharge > 0 || monthCharge > 0
                    //     ? false
                    //     : true
                    // }
                    // onChange={(e) => availableCars(e.target.value)}
                  />
                  <p>{strings[lang].Form41} {strings[lang].Form17}</p>{" "}
                  <input
                    type="number"
                    placeholder="Eg. 25"
                    value={inFuel}
                    onClick={(e) => e.target.select()}
                    onChange={(e) => setInFuel(e.target.value)}
                  />
                  <p>{strings[lang].Form41} {strings[lang].Form18}</p>{" "}
                  <input
                    type="number"
                    placeholder="Eg. 3500"
                    value={inKm}
                    onClick={(e) => e.target.select()}
                    onChange={(e) => setInKm(e.target.value)}
                  />
                  <p>{strings[lang].Form52}</p>{" "}
                  {invoice !== "" ? <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1.3rem",
                      border: "1px dashed black",
                      cursor: "pointer",
                      textAlign: "center",
                      marginTop: "0.1rem",
                      marginBottom: "1.5rem",
                    }}
                  >
                    <span>
                      {selectedImages.length === 0
                        ? "Attach Invoice PDF file here"
                        : selectedImages[0].name}
                    </span>
                    <input
                      type="file"
                      accept="application/pdf"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </label> : ""}
                  <input
                    type="text"
                    placeholder="Comment"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  />
                  {/*
<br></br>
<p style={{ marginBottom: "1rem"}}>{strings[lang].Form48}</p>{" "}
<SignatureCanvas
penColor="black"
ref={sigRef3}
onEnd={handleSignatureEnd3}
backgroundColor="#F0F0F0"
canvasProps={{
width: 425,
height: 150,
className: "sigCanvas",
}}
/>
<button className="clear4" onClick={clearSignature3}>
{strings[lang].Form26}
</button> */}
                </div>
              </div>
              <div className="testimonials-content__title">
                <p style={{ marginTop: "1rem" }} className="error-message">
                  {strings[lang].Reservation2}{" "}
                  <i className="fa-solid fa-xmark" onClick={hideError}></i>
                </p>
                <br></br>
                <span>
                  <button
                    className="red-button"
                    style={{
                      marginRight: "1.5rem",
                      paddingLeft: "10rem",
                      paddingRight: "10rem",
                    }}
                    onClick={addForm}
                  >
                    {strings[lang].Form50}
                  </button>
                  <button
                    className="black-button"
                    style={{
                      marginLeft: "1.5rem",
                      paddingLeft: "10rem",
                      paddingRight: "10rem",
                    }}
                    onClick={() => closeForm()}
                  >
                    {strings[lang].Form54}
                  </button>
                </span>
              </div>
            </div>
          </div>
        </section>
      ) : iniForm === 2 ? (
        <section className="testimonials-section">
          <div className="container" id="content">
            <div className="testimonials-content">
              <div className="testimonials-content__title">
                <h4>
                  {strings[lang].Form1} #{filteredData[viewId].id}
                </h4>
                <span style={{ display: "flex", marginTop: "2rem" }}>
                <p>
                    {strings[lang].Form37}: {filteredData[viewId].invoice}
                  </p>
                  {lang === "ar" ? (
                    <p style={{ textAlign: "right", marginLeft: "5rem" }}>
                      {filteredData[viewId].name} :{strings[lang].Form2}
                    </p>
                  ) : (
                    <p style={{ textAlign: "left", marginLeft: "5rem" }}>
                      {strings[lang].Form2}: {filteredData[viewId].name}
                    </p>
                  )}
                  <p style={{ marginLeft: "5rem" }}>
                    {strings[lang].Form3}: {filteredData[viewId].mobile}
                  </p>
                  <p style={{ marginLeft: "3rem" }}>
                    {strings[lang].Form51}: {filteredData[viewId].date}
                  </p>
                </span>
              </div>
              <div
                className="all-testimonials"
                style={{ textAlign: lang === "ar" ? "right" : "left" }}
              >
                <div id="table" className="all-testimonials__table">
                  <table className="invoice-table">
                    <thead>
                      <tr>
                        <th>
                          <p></p>
                        </th>
                        <th>
                          <b>{strings[lang].Form4}</b>
                        </th>
                        <th>
                          <b>{strings[lang].Form5}</b>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <b>{strings[lang].Form7}</b>
                        </td>
                        <td style={{ textAlign: "center" }}>{filteredData[viewId].dayCharge}</td>
                        <td style={{ textAlign: "center" }}>{filteredData[viewId].dayDinar}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>{strings[lang].Form8}</b>
                        </td>
                        <td style={{ textAlign: "center" }}>{filteredData[viewId].weekCharge}</td>
                        <td style={{ textAlign: "center" }}>{filteredData[viewId].weekDinar}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>{strings[lang].Form9}</b>
                        </td>
                        <td style={{ textAlign: "center" }}>{filteredData[viewId].monthCharge}</td>
                        <td style={{ textAlign: "center" }}>{filteredData[viewId].monthDinar}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>{strings[lang].Form10}</b>
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center" }}>{filteredData[viewId].discountDinar}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>{strings[lang].Form11}</b>
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center" }}>{filteredData[viewId].vatDinar}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>{strings[lang].Form12}</b>
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center" }}>{filteredData[viewId].insuranceDinar}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>{strings[lang].Form13}</b>
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center" }}>{filteredData[viewId].deliveryDinar}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>{strings[lang].Form14}</b>
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center" }}>{filteredData[viewId].totalDinar}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  className="all-testimonials__box"
                  style={{ display: "grid" }}
                >
                  {/* <p>
                    {strings[lang].Form28}: {filteredData[viewId].FileNo}
                  </p> */}
                  <p>
                    {strings[lang].Truck6}:{" "}
                    {filteredData[viewId].company}
                  </p>
                  <p>
                    {strings[lang].Taxi3}:{" "}
                    {filteredData[viewId].fileNo}
                  </p>
                  <p>
                    {strings[lang].Form29}:{" "}
                    {filteredData[viewId].drivingLicence}
                  </p>
                  {/* {lang === "ar" ? (
                    <p style={{ textAlign: "right" }}>
                      {filteredData[viewId].issuePlace} :{strings[lang].Form30}
                    </p>
                  ) : (
                    <p style={{ textAlign: "left" }}>
                      {strings[lang].Form30}: {filteredData[viewId].issuePlace}
                    </p>
                  )}
                  <p>
                    {strings[lang].Form31}: {filteredData[viewId].expiryDate}
                  </p> */}
                  {lang === "ar" ? (
                    <p style={{ textAlign: "right" }}>
                      {filteredData[viewId].carModel} :{strings[lang].Form32}
                    </p>
                  ) : (
                    <p style={{ textAlign: "left" }}>
                      {strings[lang].Form32}: {filteredData[viewId].carModel}
                    </p>
                  )}
                  <p>
                    {strings[lang].Form33}: {filteredData[viewId].carNo}
                  </p>
                  <p>
                    {strings[lang].Form34}: {formatDate(filteredData[viewId].timeOut)}
                  </p>
                  <p>
                  {strings[lang].Form15} {strings[lang].Form17} {filteredData[viewId].outFuel}
                  </p>
                  <p>
                  {strings[lang].Form15} {strings[lang].Form18}: {filteredData[viewId].outKm}
                  </p>
                  <p>
                  {strings[lang].Form35}: {formatDate(filteredData[viewId].timeIn)}
                  </p>
                  {filteredData[viewId].inKm > 0 ? <><p>
                      {strings[lang].Form41} {strings[lang].Form17} {filteredData[viewId].inFuel} ({filteredData[viewId].inFuel - filteredData[viewId].outFuel})
                    </p><p>
                        {strings[lang].Form41} {strings[lang].Form18}: {filteredData[viewId].inKm} ({filteredData[viewId].inKm - filteredData[viewId].outKm})
                      </p></>: null}
                  <p>
                    {strings[lang].Form57}: {filteredData[viewId].comment}
                  </p>
                    <p>
                      {strings[lang].Form52}:{" "}
                      <a
                       target="_blank" rel="noopener noreferrer"
                        href={
                          "https://api.hardrockrental.net/forms/" +
                          `${filteredData[viewId].images}?n=`+random
                        }
                      >
                        {filteredData[viewId].images}
                      </a>
                    </p>
                    <p>
                      {strings[lang].Form60}:{" "}
                      <a
                       target="_blank" rel="noopener noreferrer"
                        href={
                          "https://api.hardrockrental.net/forms/" +
                          `${filteredData[viewId].images1}?n=`+random
                        }
                      >
                        {filteredData[viewId].images1}
                      </a>
                    </p>
                </div>
              </div>
              <div className="testimonials-content__title">
                <p style={{ marginTop: "1rem" }} className="error-message">
                  {strings[lang].Reservation2}{" "}
                  <i className="fa-solid fa-xmark" onClick={hideError}></i>
                </p>
                {visibleButtons === true ? (
                  <>
                    <br></br>
                    <span>
                      <button
                        className="red-button"
                        style={{
                          marginRight: "1.5rem",
                          paddingLeft: "10rem",
                          paddingRight: "10rem",
                        }}
                        onClick={() => pregeneratePdf()}
                      >
                        {strings[lang].Form55}
                      </button>
                      <button
                        className="black-button"
                        style={{
                          marginLeft: "1.5rem",
                          paddingLeft: "10rem",
                          paddingRight: "10rem",
                        }}
                        onClick={() => setIniForm(0)}
                      >
                        {strings[lang].Form54}
                      </button>
                    </span>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </section>
      ) : iniForm === 3 ? (
        <section className="testimonials-section">
          <div className="container">
            <div className="testimonials-content">
              <div className="testimonials-content__title">
                <h2>{strings[lang].Form1}</h2>
                <h4>#{id}</h4>
                <span>
                  <input
                    type="text"
                    placeholder={strings[lang].Form2}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />{" "}
                  &nbsp;{" "}
                  <input
                    type="number"
                    placeholder={strings[lang].Form3}
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                  />{" "}
                  &nbsp;{" "}
                  <input
                    type="date"
                    placeholder="Date"
                    value={date}
                    disabled
                    onChange={(e) => setDate(e.target.value)}
                  />
                </span>
              </div>
              <div
                className="all-testimonials"
                style={{ textAlign: lang === "ar" ? "right" : "left" }}
              >
                <div className="all-testimonials__table">
                  <table>
                    <thead>
                      <tr>
                        <th>
                          <p></p>
                        </th>
                        <th>
                          <b>{strings[lang].Form4}</b>
                        </th>
                        <th>
                          <b>{strings[lang].Form5}</b>
                        </th>
                        {/* <th>
                          <b>{strings[lang].Form6}</b>
                        </th> */}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <p>{strings[lang].Form7}</p>
                        </td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={dayCharge}
                            onClick={() => setDayCharge("")}
                            onChange={(e) => setDayCharge(e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={dayDinar}
                            onClick={() => setDayDinar("")}
                            onChange={(e) => setDayDinar(e.target.value)}
                          />
                        </td>
                        {/* <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={dayFils}
                            onClick={() => setDayFils("")}
                            onChange={(e) => setDayFils(e.target.value)}
                          />
                        </td> */}
                      </tr>
                      <tr>
                        <td>
                          <p>{strings[lang].Form8}</p>
                        </td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={weekCharge}
                            onClick={() => setWeekCharge("")}
                            onChange={(e) => setWeekCharge(e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={weekDinar}
                            onClick={() => setWeekDinar("")}
                            onChange={(e) => setWeekDinar(e.target.value)}
                          />
                        </td>
                        {/* <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={weekFils}
                            onClick={() => setWeekFils("")}
                            onChange={(e) => setWeekFils(e.target.value)}
                          />
                        </td> */}
                      </tr>
                      <tr>
                        <td>
                          <p>{strings[lang].Form9}</p>
                        </td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={monthCharge}
                            onClick={() => setMonthCharge("")}
                            onChange={(e) => setMonthCharge(e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={monthDinar}
                            onClick={() => setMonthDinar("")}
                            onChange={(e) => setMonthDinar(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>{strings[lang].Form10}</p>
                        </td>
                        <td></td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={discountDinar}
                            onChange={(e) => setDiscountDinar(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>{strings[lang].Form11}</p>
                        </td>
                        <td></td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={vatDinar}
                            onChange={(e) => setVatDinar(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>{strings[lang].Form12}</p>
                        </td>
                        <td></td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={insuranceDinar}
                            onChange={(e) => setInsuranceDinar(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>{strings[lang].Form13}</p>
                        </td>
                        <td></td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={deliveryDinar}
                            onChange={(e) => setDeliveryDinar(e.target.value)}
                          />
                        </td>
                        {/* <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={deliveryFils}
                            onChange={(e) => setDeliveryFils(e.target.value)}
                          />
                        </td> */}
                      </tr>
                      <tr>
                        <td>
                          <p>{strings[lang].Form14}</p>
                        </td>
                        <td></td>
                        <td>
                          <input
                            type="number"
                            placeholder="0"
                            value={totalDinar}
                            onClick={calcTotalDinar}
                            onChange={(e) => setTotalDinar(e.target.value)}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div
                  className="all-testimonials__box"
                  style={{ display: "grid" }}
                >
                  <select value={company} onChange={handleCompany}>
        {companies.map((data, idx) => (
              <option key={idx} value={data}> {data} </option>
        ))}
        </select>
                  {/* <p>{strings[lang].Form28}</p>{" "}
                  <input
                    type="number"
                    placeholder="Res. Telephone"
                    value={FileNo}
                    onChange={(e) => setFileNo(e.target.value)}
                  /> */}
                  <p>{strings[lang].Taxi3}</p>{" "}
                  <input
                    type="text"
                    placeholder="File No."
                    value={fileNo}
                    onChange={(e) => setFileNo(e.target.value)}
                  />
                  <p>{strings[lang].Form29}</p>{" "}
                  <input
                    type="number"
                    placeholder="Driving Licence No."
                    value={drivingLicence}
                    onChange={(e) => setDrivingLicence(e.target.value)}
                  />
                  <p>{strings[lang].Form32}</p>{" "}
                  <select
                    value={carModel}
                    onChange={(e) => setCarModel(e.target.value)}
                  >
                    {cars &&
                      cars.map(function (d, idx) {
                        return (
                          <option key={idx} value={d.name + " " + d.model}>
                            {d.name} {d.model}
                          </option>
                        );
                      })}
                  </select>
                  <p>{strings[lang].Form33}</p>{" "}
                  <input
                    type="number"
                    placeholder="Car No."
                    value={carNo}
                    onChange={(e) => setCarNo(e.target.value)}
                  />
                  <p>{strings[lang].Form34}</p>{" "}
                  <input
                    type="datetime-local"
                    placeholder="Date / Time out"
                    value={timeOut}
                    min={new Date((new Date().getTime()) + 3 * 60 * 60 * 1000).toISOString().slice(0, 16)}
                    onChange={(e) => setTimeOut(e.target.value)}
                  />
                  <p>{strings[lang].Form15} {strings[lang].Form17}</p>{" "}
                  <input
                    type="number"
                    placeholder="Eg. 12"
                    value={outFuel}
                    onChange={(e) => setOutFuel(e.target.value)}
                  />
                  <p>{strings[lang].Form15} {strings[lang].Form18}</p>{" "}
                  <input
                    type="number"
                    placeholder="Eg. 12345"
                    value={outKm}
                    onChange={(e) => setOutKm(e.target.value)}
                  />
                  <p>{strings[lang].Form35}</p>{" "}
                  <input
                    type="datetime-local"
                    placeholder="Date / Time in"
                    min={new Date((new Date().getTime()) + 3 * 60 * 60 * 1000).toISOString().slice(0, 16)}
                    value={timeIn}
                    onChange={(e) => setTimeIn(e.target.value)}
                  />
                  <p>{strings[lang].Form41} {strings[lang].Form17}</p>{" "}
                  <input
                    type="number"
                    placeholder="Eg. 12"
                    value={inFuel}
                    onChange={(e) => setInFuel(e.target.value)}
                  />
                  <p>{strings[lang].Form41} {strings[lang].Form18}</p>{" "}
                  <input
                    type="number"
                    placeholder="Eg. 12345"
                    value={inKm}
                    onChange={(e) => setInKm(e.target.value)}
                  /> 
                  <p>{strings[lang].Form57}</p>{" "}
                  <textarea
                    placeholder="Comment"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  />
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1.3rem",
                      border: "1px dashed black",
                      cursor: "pointer",
                      textAlign: "center",
                      marginTop: "0.1rem",
                      marginBottom: "1.5rem",
                    }}
                  >
                    <span>
                      {selectedImages.length === 0
                        ? "Attach Case PDF file here"
                        : selectedImages[0].name }
                    </span>
                    <input
                      type="file"
                      accept="application/pdf"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </label>
                </div>
              </div>
              <div className="testimonials-content__title">
                <p style={{ marginTop: "1rem" }} className="error-message">
                  {strings[lang].Reservation2}{" "}
                  <i className="fa-solid fa-xmark" onClick={hideError}></i>
                </p>
                <br></br>
                <span>
                  <button
                    className="red-button"
                    style={{
                      marginRight: "1.5rem",
                      paddingLeft: "10rem",
                      paddingRight: "10rem",
                    }}
                    onClick={updateForm}
                  >
                    {strings[lang].Form50}
                  </button>
                  <button
                    className="black-button"
                    style={{
                      marginLeft: "1.5rem",
                      paddingLeft: "10rem",
                      paddingRight: "10rem",
                    }}
                    onClick={closeUpdateForm}
                  >
                    {strings[lang].Form54}
                  </button>
                </span>
              </div>
            </div>
          </div>
        </section>
      ) : iniForm === 4 ? (
        <section className="testimonials-section" id="content">
          <div className="container">
            <div className="testimonials-content">
              <div className="testimonials-content__title">
                <h2>{strings[lang].Form1}</h2>
                <h4>#{filteredData[viewId].id}</h4>
                <span style={{ display: "flex", marginTop: "2rem" }}>
                  <h4>
                    {strings[lang].Form2}: {filteredData[viewId].name}
                  </h4>
                  <h4 style={{ marginLeft: "5rem" }}>
                    {strings[lang].Form3}: {filteredData[viewId].mobile}
                  </h4>
                  <h4 style={{ marginLeft: "3rem" }}>
                    {strings[lang].Form51}: {filteredData[viewId].date}
                  </h4>
                </span>
              </div>
              <div className="all-testimonials">
                <div className="all-testimonials__table">
                  <table>
                    <thead>
                      <tr>
                        <th>
                          <p></p>
                        </th>
                        <th>
                          <b>{strings[lang].Form4}</b>
                        </th>
                        <th>
                          <b>{strings[lang].Form5}</b>
                        </th>
                        <th>
                          <b>{strings[lang].Form6}</b>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <b>{strings[lang].Form7}</b>
                        </td>
                        <td>{filteredData[viewId].dayCharge}</td>
                        <td>{filteredData[viewId].dayDinar}</td>
                        <td>{filteredData[viewId].dayFils}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>{strings[lang].Form8}</b>
                        </td>
                        <td>{filteredData[viewId].weekCharge}</td>
                        <td>{filteredData[viewId].weekDinar}</td>
                        <td>{filteredData[viewId].weekFils}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>{strings[lang].Form9}</b>
                        </td>
                        <td>{filteredData[viewId].monthCharge}</td>
                        <td>{filteredData[viewId].monthDinar}</td>
                        <td>{filteredData[viewId].monthFils}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>{strings[lang].Form10}</b>
                        </td>
                        <td></td>
                        <td>{filteredData[viewId].discountDinar}</td>
                        <td>{filteredData[viewId].discountFils}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>{strings[lang].Form11}</b>
                        </td>
                        <td></td>
                        <td>{filteredData[viewId].vatDinar}</td>
                        <td>{filteredData[viewId].vatFils}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>{strings[lang].Form12}</b>
                        </td>
                        <td></td>
                        <td>{filteredData[viewId].insuranceDinar}</td>
                        <td>{filteredData[viewId].insuranceFils}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>{strings[lang].Form13}</b>
                        </td>
                        <td></td>
                        <td>{filteredData[viewId].deliveryDinar}</td>
                        <td>{filteredData[viewId].deliveryFils}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>{strings[lang].Form14}</b>
                        </td>
                        <td></td>
                        <td>{filteredData[viewId].totalDinar}</td>
                        <td>{filteredData[viewId].totalFils}</td>
                      </tr>
                    </tbody>
                  </table>
                  <h2
                    style={{
                      marginTop: "2rem",
                      backgroundColor: "#F0F0F0",
                      textAlign: "center",
                      border: "1px dotted black",
                      marginBottom: "1rem",
                    }}
                  >
                    {" "}
                    {strings[lang].Form15}
                  </h2>
                  <span>{strings[lang].Form16}</span>
                  <br></br>
                  {Array.from(
                    Array(parseInt(filteredData[viewId].images)),
                    (e, i) => {
                      return (
                        <img
                          key={i}
                          src={
                            "https://api.hardrockrental.net/forms/" +
                            "out" +
                            filteredData[viewId].id +
                            "img" +
                            i
                          }
                          style={{
                            width: 200,
                            marginTop: "1rem",
                            marginBottom: "1rem",
                          }}
                          onClick={() =>
                            window.open(
                              "https://api.hardrockrental.net/forms/" +
                                "out" +
                                filteredData[viewId].id +
                                "img" +
                                i,
                              "_blank"
                            )
                          }
                          alt="does not exist"
                        />
                      );
                    }
                  )}
                  <br></br>
                  <span>
                    {strings[lang].Form17} {filteredData[viewId].outFuel}
                  </span>
                  <br></br>
                  <span>
                    {strings[lang].Form18}: {filteredData[viewId].outKm}
                  </span>
                  <br></br>
                  <input
                    type="checkbox"
                    readOnly
                    checked={JSON.parse(filteredData[viewId].sticker)}
                  />
                  &nbsp;<span>{strings[lang].Form19}</span>
                  <br></br>
                  <input
                    type="checkbox"
                    readOnly
                    checked={JSON.parse(filteredData[viewId].aerial)}
                  />
                  &nbsp;<span>{strings[lang].Form20}</span>
                  <br></br>
                  <input
                    type="checkbox"
                    readOnly
                    checked={JSON.parse(filteredData[viewId].radio)}
                  />
                  &nbsp;<span>{strings[lang].Form21}</span>
                  <br></br>
                  <input
                    type="checkbox"
                    readOnly
                    checked={JSON.parse(filteredData[viewId].tools)}
                  />
                  &nbsp;<span>{strings[lang].Form22}</span>
                  <br></br>
                  <input
                    type="checkbox"
                    readOnly
                    checked={JSON.parse(filteredData[viewId].jack)}
                  />
                  &nbsp;<span>{strings[lang].Form23}</span>
                  <br></br>
                  <input
                    type="checkbox"
                    readOnly
                    checked={JSON.parse(filteredData[viewId].spare)}
                  />
                  &nbsp;<span>{strings[lang].Form24}</span>
                  <br></br>
                  <br></br>
                  <b>{strings[lang].Form25}:</b>
                  <img
                    src={filteredData[viewId].signature}
                    style={{ width: "40rem" }}
                    alt="Signature does not exist"
                  />
                  <br></br>
                  <h2
                    style={{
                      marginTop: "2rem",
                      backgroundColor: "#F0F0F0",
                      textAlign: "center",
                      border: "1px dotted black",
                      marginBottom: "1rem",
                    }}
                  >
                    {strings[lang].Form41}
                  </h2>
                  <span>{strings[lang].Form16}</span>
                  <br></br>
                  {Array.from(
                    Array(parseInt(filteredData[viewId].images1)),
                    (e, i) => {
                      return (
                        <img
                          key={i}
                          src={
                            "https://api.hardrockrental.net/forms/" +
                            "in" +
                            filteredData[viewId].id +
                            "img" +
                            i
                          }
                          style={{
                            width: 200,
                            marginTop: "1rem",
                            marginBottom: "1rem",
                          }}
                          onClick={() =>
                            window.open(
                              "https://api.hardrockrental.net/forms/" +
                                "in" +
                                filteredData[viewId].id +
                                "img" +
                                i,
                              "_blank"
                            )
                          }
                          alt="does not exist"
                        />
                      );
                    }
                  )}
                  <br></br>
                  <span>
                    {strings[lang].Form17} {filteredData[viewId].inFuel}
                  </span>
                  <br></br>
                  <span>
                    {strings[lang].Form18}: {filteredData[viewId].inKm}
                  </span>
                  <br></br>
                  <br></br>
                  <b>{strings[lang].Form27}:</b>
                  <img
                    src={filteredData[viewId].comment}
                    style={{ width: "40rem" }}
                    alt="Signature does not exist"
                  />
                </div>
                <div
                  className="all-testimonials__box"
                  style={{ display: "grid" }}
                >
                  <p>
                    {strings[lang].Form28}: {filteredData[viewId].fileNo}
                  </p>
                  <p>
                    {strings[lang].Form29}:{" "}
                    {filteredData[viewId].drivingLicence}
                  </p>
                  <p>
                    {strings[lang].Form30}: {filteredData[viewId].issuePlace}
                  </p>
                  <p>
                    {strings[lang].Form31}: {filteredData[viewId].expiryDate}
                  </p>
                  <p>
                    {strings[lang].Form32}: {filteredData[viewId].carModel}
                  </p>
                  <p>
                    {strings[lang].Form33}: {filteredData[viewId].carNo}
                  </p>
                  <p>
                    {strings[lang].Form34}: {filteredData[viewId].timeOut}
                  </p>
                  <p>
                    {strings[lang].Form35}: {filteredData[viewId].timeIn}
                  </p>
                  <p>
                    {strings[lang].Form36}: {filteredData[viewId].timeReplaced}
                  </p>
                  <p>
                    {strings[lang].Form37}: {filteredData[viewId].invoice}
                  </p>
                  <p>
                    {strings[lang].Form38}: {filteredData[viewId].company}
                  </p>
                  <b>{strings[lang].Form39}:</b>
                  <img
                    src={filteredData[viewId].signature2}
                    style={{ width: "40rem" }}
                    alt="Signature does not exist"
                  />
                  <br></br>
                  <b>{strings[lang].Form40}:</b>
                  <p>{filteredData[viewId].refund}</p>
                  <br></br>
                  <b>{strings[lang].Form40}</b>
                  <p style={{ fontSize: "1.3rem" }}>{strings[lang].Form42}</p>
                  <p style={{ fontSize: "1.3rem" }}>{strings[lang].Form43}</p>
                  <p style={{ fontSize: "1.3rem" }}>{strings[lang].Form44}</p>
                  <p style={{ fontSize: "1.3rem" }}>{strings[lang].Form45}</p>
                  <p style={{ fontSize: "1.3rem" }}>{strings[lang].Form46}</p>
                  <b style={{ fontSize: "1.4rem", marginTop: "2.5rem" }}>
                    {strings[lang].Form47}
                  </b>
                  <br></br>
                  <b>{strings[lang].Form48}:</b>
                  <img
                    src={filteredData[viewId].signature3}
                    style={{ width: "40rem" }}
                    alt="Signature does not exist"
                  />
                </div>
              </div>
              <div className="testimonials-content__title">
                <p style={{ marginTop: "1rem" }} className="error-message">
                  {strings[lang].Reservation2}{" "}
                  <i className="fa-solid fa-xmark" onClick={hideError}></i>
                </p>
                {/* <b>{strings[lang].Form49}:</b>
<br></br>
<img
src={filteredData[viewId].signature4}
style={{ width: "40rem" }}
alt="Signature does not exist"
/> */}
              </div>
            </div>
          </div>
        </section>
      ) : (
        <>
          <div className="team-container" id="content1" style={{ paddingBottom: "0px" }}>
            <p>
              {strings[lang].Vehicles1}{" "}
              {sessionStorage.getItem("userdata").toUpperCase()}{" "}
              <i className="fa-regular fa-face-grin-beam"></i>
              <br></br> {strings[lang].Vehicles2}{" "}
              <b>
                {data.length} {strings[lang].Form52}
              </b>
              <br></br>🥇 <b>{topCar(data)}</b> - Top Rented
              <br></br>🥇 <b>{topRenter(data)}</b> - Top Renter
            </p>
            <input
              placeholder={strings[lang].Vehicles5}
              value={search}
              id="search"
              type="text"
              onChange={(e) => searchSpace(e)}
            />
            <button
              type="submit"
              style={{ borderRadius: "50px", boxShadow: "none" }}
              onClick={() => addNewForm()}
            >
              {strings[lang].Form53}
            </button>
            <br></br>
            {/* <h2>{strings[lang].Form1}</h2>
<button onClick={() => setIniForm(1)}>FILL A NEW FORM</button> */}
          </div>
          <div className="book-content__box">
            <table
            ref={tableRef}
              style={{
                alignSelf: "center",
                textAlign: lang === "ar" ? "right" : "left",
                fontSize: "15px",
              }}
            >
              <thead>
                <tr>
                  <th>
                    <b>#</b>
                  </th>
                  <th>
                    <b>{strings[lang].Form37}</b>
                  </th>
                  <th>
                    <b>{strings[lang].Form2}</b>
                  </th>
                  <th>
                    <b>{strings[lang].Form3}</b>
                  </th>
                  <th>
                    <b>{strings[lang].Form29}</b>
                  </th>
                  <th>
                    <b>{strings[lang].Form32}</b>
                  </th>
                  <th>
                    <b>{strings[lang].Form33}</b>
                  </th>
                  <th>
                    <b>{strings[lang].Truck6}</b>
                  </th>
                  <th>
                    <b>{strings[lang].Taxi3}</b>
                  </th>
                  <th>
                    <b>{strings[lang].Reservation9+" (BD)"}</b>
                  </th>
                  {sessionStorage.getItem("usertype") === md5("admin") && (
                    <>
                    <th>
                      <b>{strings[lang].Form39}</b>
                    </th>
                    <th>
                      <b>{strings[lang].Form61}</b>
                    </th>
                    </>
                  )}
                  <th>
                  <i className="fa-solid fa-download" onClick={() => openDownloadModal()}></i>
                  </th>
                </tr>
              </thead>
              {filteredData &&
                filteredData.slice(0, visibleRows).map(function (d, idx) {
                  return (
                    <tbody key={idx}>
                      <tr key={idx}>
                        <td>{idx+1}.</td>
                        <td>{d.invoice}</td>
                        <td>{d.name}</td>
                        <td>{d.mobile}</td>
                        <td>{d.drivingLicence}</td>
                        <td>{d.carModel}</td>
                        <td>{d.carNo}</td>
                        <td>{d.company}</td>
                        <td>{d.fileNo}</td>
                        <td>{d.totalDinar}</td>
                        {sessionStorage.getItem("usertype") ===
                          md5("admin") &&
                          <><td>{d.signature.toUpperCase()}</td>
                          <td>{d.signature2.toUpperCase()}</td></>}
                        <td>
                          <i
                            className="fa-regular fa-eye fa-lg"
                            onClick={() => viewForm(idx)}
                          ></i>
                          { d.inKm <= 0 ? <i
                            className="fa-solid fa-pen-to-square fa-lg"
                            onClick={() =>
                              editForm(
                                idx,
                                d.id,
                                d.name,
                                d.mobile,
                                d.date,
                                d.fileNo,
                                d.drivingLicence,
                                d.issuePlace,
                                d.expiryDate,
                                d.carModel,
                                d.carNo,
                                d.timeOut,
                                d.timeIn,
                                d.timeReplaced,
                                d.invoice,
                                d.company,
                                d.refund,
                                d.images,
                                d.images1,
                                d.dayCharge,
                                d.dayDinar,
                                d.dayFils,
                                d.weekCharge,
                                d.weekDinar,
                                d.weekFils,
                                d.monthCharge,
                                d.monthDinar,
                                d.monthFils,
                                d.discountDinar,
                                d.discountFils,
                                d.vatDinar,
                                d.vatFils,
                                d.insuranceDinar,
                                d.insuranceFils,
                                d.deliveryDinar,
                                d.deliveryFils,
                                d.totalDinar,
                                d.totalFils,
                                d.outFuel,
                                d.inFuel,
                                d.outKm,
                                d.inKm,
                                d.sticker,
                                d.aerial,
                                d.radio,
                                d.tools,
                                d.jack,
                                d.spare,
                                d.signature,
                                d.comment,
                                d.signature2,
                                d.signature3,
                                d.signature4
                              )
                            }
                            style={{
                              marginLeft: "1rem"
                            }}
                          ></i>: null}
                          {d.refund === "0" && d.inKm > "0" && d.inFuel > "0" ? <i className="fa-solid fa-money-bill-transfer fa-lg"
                          onMouseDown={handlePressStart} 
                          onMouseUp={() => handlePressEnd(d.id, d.insuranceDinar, d.totalDinar)} 
                          onMouseLeave={() => handlePressEnd(d.id, d.insuranceDinar, d.totalDinar)}
                          onTouchStart={handlePressStart} 
                          onTouchEnd={() => handlePressEnd(d.id, d.insuranceDinar, d.totalDinar)}
                          style={{ marginLeft: "1rem", color: "green" }}></i> : null}
                        </td>
                        {d.refund === "0" && d.inKm > "0" && d.inFuel > "0" && isNearBySixHours(d.signature4) ? <CountdownTimer targetDateStr={d.signature4} /> : null}
                        {d.inKm === "0" && d.inFuel === "0" &&  isNearBySixHours(d.timeIn) ? <CountdownTimer targetDateStr={d.timeIn} /> : null}
                      </tr>
                    </tbody>
                  );
                })}
                {visibleRows < data.length && sessionStorage.getItem("usertype") === md5("admin") ? (
                        <tfoot><tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                        <i className="fa-solid fa-circle-chevron-down fa-lg" onClick={handleLoadMore}></i>
                        <i className="fa-solid fa-border-all fa-lg" style={{ marginLeft: "1rem" }} onClick={handleShowAll}></i>
                        {visibleRows > 10 ?<i className="fa-solid fa-circle-chevron-up fa-lg" style={{ marginLeft: "1rem" }} onClick={handleLoadLess}></i> : ""}
                        </td></tr></tfoot>)
                        : visibleRows < data.length && sessionStorage.getItem("usertype") === md5("team") ? (
                        <tfoot><tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                        <i className="fa-solid fa-circle-chevron-down fa-lg" onClick={handleLoadMore}></i>
                        <i className="fa-solid fa-border-all fa-lg" style={{ marginLeft: "1rem" }} onClick={handleShowAll}></i>
                        {visibleRows > 10 ?<i className="fa-solid fa-circle-chevron-up fa-lg" style={{ marginLeft: "1rem" }} onClick={handleLoadLess}></i> : ""}
                        </td></tr></tfoot>
                        ) : ""}
            </table>
          </div>

          {/* ------------------------------------------- Download modal ----------------------------------- */}
          
                <div className={`booking-modal ${dldmodal ? "active-modal" : ""}`}>
                  {/* title */}
                  {/* car info */}
                  <div className="booking-modal__car-info">
                    <div className="team-container__box">
                    <h2><i className="fa-solid fa-receipt fa-2xl" onClick={() => openDownloadModal()}></i></h2><br></br>
                    <select disabled={disableComp} id="myCompany1" onChange={handleCompany}>
                    <option value="" >{strings[lang].Truck8}</option>
                  {companies.map((data, idx) => (
                        <option key={idx} value={data}> {data} </option>
                  ))}
                  </select>
                  <span>
                  <input type="date" disabled={company === "" ? true : false} placeholder={strings[lang].Rent6} value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                  <input type="date" disabled={startDate === "" ? true : false} placeholder={strings[lang].Rent6} value={endDate} style={{ marginLeft: "5px" }} onChange={(e) => FormDld(e.target.value)} />
                  </span>
                          <button type="submit" disabled={endDate === "" ? true : false} style={{ backgroundColor: endDate === "" ? "grey" : "" }} onClick={() => getInvoice()} >
                          {strings[lang].Form55} INVOICE
                          </button>
                          <button type="submit" disabled={endDate === "" ? true : false} style={{ backgroundColor: endDate === "" ? "grey" : "", marginTop: "15px" }} onClick={() => openDownloadModal()}><DownloadTableExcel
                              filename={company+"_"+formattedDate}
                              sheet="Car Replacement"
                              currentTableRef={tableRef.current}
                          >{strings[lang].Form55} EXCEL</DownloadTableExcel></button>
                        </div>
                  </div>
                </div>
        </>
      )}
    </>
  );
}

export default Rents;
